export default __webpack_public_path__ + "static/main-video-be7bd7476931e887a99f2a7e6f056ec6.mp4";